import type { FormSubmissionAction, LoginMethod } from './constants';

import { FORM_SUBMISSION_ACTIONS, LOGIN_METHODS } from './constants';

export interface UserRegistrationStatus {
	isLoggedIn: boolean;
	loginMethod?: LoginMethod;
	hasCompletedRegistration: boolean;
}

export function useFormSubmissionStrategy() {
	function getSubmissionAction(
		status: UserRegistrationStatus
	): FormSubmissionAction {
		if (!status.isLoggedIn) {
			return FORM_SUBMISSION_ACTIONS.OTP;
		}

		if (status.hasCompletedRegistration) {
			return FORM_SUBMISSION_ACTIONS.SUBMIT;
		}

		const isSocialLogin =
			status.loginMethod === LOGIN_METHODS.GOOGLE ||
			status.loginMethod === LOGIN_METHODS.FACEBOOK;

		if (isSocialLogin) {
			return FORM_SUBMISSION_ACTIONS.COMPLETE_SOCIAL;
		}

		if (status.loginMethod === LOGIN_METHODS.PHONE) {
			return FORM_SUBMISSION_ACTIONS.COMPLETE_PHONE;
		}

		// Fallback for unhandled login methods with incomplete registration.
		// Returning SUBMIT is incorrect. Throwing an error makes the unhandled state explicit.
		throw new Error(
			`Unhandled incomplete registration for login method: ${status.loginMethod}`
		);
	}

	return {
		getSubmissionAction
	};
}
